import { stringify } from 'qs'
import assert from './assert'

export const sourcePath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/overview`
}

export const sourceRunPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug', 'runId'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/overview/runs/${args.runId}`
}

export const visualTaggerPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/visual-tagger`
}

/**
 * Generates a URL for the Cloud Source connect path
 * @typedef {Object} Args
 * @property {string} workspaceSlug
 * @property {string} sourceSlug
 * @property {string} sourceMetadataSlug
 * @param {Args} args
 */
export const cloudSourceConnectPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug', 'sourceMetadataSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/connect/${args.sourceMetadataSlug}`
}

export const sourceSetupPath = args => {
  assert(args, ['workspaceSlug', 'sourceMetadataSlug'])
  return `/${args.workspaceSlug}/sources/setup/${args.sourceMetadataSlug}`
}

export const sourceSettingsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings`
}

export const sourceSettingsLabelsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/labels`
}

export const sourceSettingsSqlPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/sql`
}

export const sourceSettingsOAuthPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/oauth`
}

export const sourceSettingsCollaboratorsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/collaborators`
}

export const sourceSettingsConnectionPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/connection`
}

export const sourceSettingsMovePath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/move`
}

export const sourceSettingsWebhookPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/endpoint`
}

export const sourceSettingsSchemaConfigPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/schema`
}

export const sourceSettingsSchemaClearPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/schema/clear`
}

export const sourceSettingsKeysPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/keys`
}

export const sourceSettingsCrossDomainAnalyticsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/cross-domain-analytics`
}

export const sourceSettingsPluginsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/plugins`
}

export const sourceSettingsSelectiveSyncPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/selective-sync`
}

export const sourceSettingsAnalyticsJsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/analytics-js`
}

export const sourceSettingsAccountViewPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/settings/account-setup`
}

export const sourceDebuggerPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/debugger`
}

export const sourceFunctionErrorsPath = args => {
  assert(args, ['workspaceSlug', 'sourceSlug'])
  return `/${args.workspaceSlug}/sources/${args.sourceSlug}/function-errors`
}

export const sourceStarterTrackingPlanSetupPath = args => {
  assert(args, ['workspaceSlug', 'sourceId'])
  return `/${args.workspaceSlug}/home/starter-tracking-plan?sourceId=${args.sourceId}`
}

export const sourcesPath = args => {
  assert(args, 'workspaceSlug')

  const path = `/${args.workspaceSlug}/sources`

  if (args.query && args.query.type) {
    const query = stringify({
      type: args.query.type
    })

    return `${path}?${query}`
  }

  return path
}

export const sourcesCatalogPath = args => {
  assert(args, 'workspaceSlug')
  return `/${args.workspaceSlug}/sources/catalog`
}

export const sourcesCatalogItemPath = args => {
  assert(args, ['workspaceSlug', 'sourceMetadataSlug'])
  const { workspaceSlug, sourceMetadataSlug, category } = args
  let basePath = `/${workspaceSlug}/sources/catalog/${sourceMetadataSlug}`
  if (category) {
    basePath = basePath.concat(`?category=${category}`)
  }
  return basePath
}
